// extracted by mini-css-extract-plugin
export default {"CompetitionsContainer":"Competitions_CompetitionsContainer__x60AH","GameScheduleContainer":"Competitions_GameScheduleContainer__9heuZ"};